import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledRadioButton,
  Wrapper,
  Label,
  RadioButtonGroup,
} from './styles';

const RadioButton = ({ label, ...props }) => (
  <Wrapper>
    <input type="radio" {...props} />
    <StyledRadioButton />
    {label && <Label>{label}</Label>}
  </Wrapper>
);

RadioButton.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default RadioButton;
export { RadioButtonGroup };
